import { render } from "./ObjectCode.vue?vue&type=template&id=4ed540a6&scoped=true&ts=true"
import script from "./ObjectCode.vue?vue&type=script&lang=ts"
export * from "./ObjectCode.vue?vue&type=script&lang=ts"

import "./ObjectCode.vue?vue&type=style&index=0&id=4ed540a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed540a6"]])

export default __exports__